<template lang="pug">
    control-modal-layout.creator-mention-dropdown-modal(v-if="creators && creators.length" v-bind="$attrs" :offsetX="0" :offsetY="0" placement="bottom-start" ref="modal")
        creators-list-control(:creators="creators" :selectedIndex="selectedIndex" :clickCallback="chooseCreatorCallback")
</template>

<script>
import _ from 'lodash'
import UserService from '../../services/user-service'

export default {
    name: 'creator-mention-dropdown-modal',

    props: {
        chooseCreatorCallback: {
            type: Function,
        },
    },

    data() {
        return {
            lastSearch: '',
            creators: null,
            loadCancel: null,
            selectedIndex: null,
        }
    },

    methods: {
        search(search) {
            if (this.lastSearch === search) {
                return
            }

            const hasLastSearch = !!this.lastSearch
            this.lastSearch = search

            if (hasLastSearch) {
                this.loadDebounce()
            }
            else {
                this.load()
            }
        },

        load() {
            if (this.loadCancel) {
                this.loadCancel()
            }

            const { promise, cancel } = UserService.search(this.lastSearch)

            promise.then(r => {
                this.creators = r.data.data
                const matchIndex = this.creators.findIndex(c => c.username == this.lastSearch)
                this.selectedIndex = matchIndex >= 0 ? matchIndex : null
            })

            this.loadCancel = cancel
        },

        selectNext() {
            if (this.selectedIndex === null || this.selectedIndex === this.creators.length - 1) {
                this.selectedIndex = 0
            }
            else {
                this.selectedIndex++
            }
        },

        selectPrev() {
            if (this.selectedIndex === null || this.selectedIndex === 0) {
                this.selectedIndex = this.creators.length - 1
            }
            else {
                this.selectedIndex--
            }
        },

        chooseSelectedCreator() {
            const creator = this.creators[this.selectedIndex]
            if (creator) {
                this.chooseCreatorCallback(creator)
            }
        },
    },

    created() {
        this.loadDebounce = _.debounce(this.load, 250)
    },
}
</script>